import React from "react";

const CardHover = ({ categories }) => {
  return (
    <div className="card-hover">
      <p>{categories}</p>
    </div>
  );
};

export default CardHover;



// WEBPACK FOOTER //
// ./src/components/CardHover.js